export function fromEntries(iterable) {
  return Object.fromEntries
    ? Object.fromEntries(iterable)
    : [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
      }, {});
}
